import { createReducer } from '../helpers';
import { MeReducerHandlers } from './handlers';
import { RequestStatus } from '../enums';

const meReducer = createReducer(
  {
    item: {},
    status: RequestStatus.IDLE,
    error: null,
  },
  {
    ...MeReducerHandlers.loginUser,
    ...MeReducerHandlers.getMe,
    ...MeReducerHandlers.logoutUser,
    ...MeReducerHandlers.updateUserInteractions,
  },
);

export default meReducer;
